import Card from "components/Card/Card";
import React, { useEffect, useState } from "react";
import {
  Col,
  Grid,
  Row,
  FormControl,
  Pagination,
  Table,
  ControlLabel,
  FormGroup,
  Button,
  Modal,
  Clearfix,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import Select from "react-select";
import NotificationSystem from "react-notification-system";
import Datetime from "react-datetime";
import moment from "moment";
import {
  getAllChallengers,
  DeleteChallenge,
  getAllChallageGroupList,
} from "../../../api/challengers/ChallengersApi";
import Axios from "axios";
import LoadingSpinner from "views/Components/loadingSpinner";
import Swal from "sweetalert2";

const Challengers = (props) => {
  const _notificationSystem = React.createRef();
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;

  const [loading, setloading] = useState(false);
  const [getAllChallenge, setGetAllChallenge] = useState([]);
  const [searchParam, setSearchParam] = useState("");
  const [type, setType] = useState("");
  const [noRecordFound, setnoRecordFound] = useState(false);
  const [getAllList, setGetAllList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  useEffect(() => {
    allChallenge(obj, 1, "");
  }, []);
  const allChallenge = (obj, page = 1, search = "", type = "") => {
    setloading(true);
    getAllChallengers(obj, search, page, type)
      .then((res) => {
        if (res.data) {
          setGetAllChallenge(res.data.data);
          setCurrentPage(res.data.current_page);
          setTotalPage(Math.ceil(res.data.total / res.data.per_page));
        }
        setloading(false);
      })
      .catch((err) => {
        console.error("Error fetching custom utility data:", err);
        setloading(false);
      });
  };
  let items = [];
  for (let number = 1; number <= totalPage; number++) {
    items.push(
      <Pagination.Item
        key={number}
        onClick={() => allChallenge(obj, number, searchParam, type)}
        active={number === currentPage}
      >
        {number}
      </Pagination.Item>
    );
  }
  const handleSearch = (event) => {
    const search = event.target.value;
    setSearchParam(search);
    setloading(true);
    getAllChallengers(obj, search, 1, type).then((res) => {
      if (res.data) {
        setGetAllChallenge(res.data.data);
        setCurrentPage(res.data.current_page);
        setTotalPage(Math.ceil(res.data.total / res.data.per_page));
      }
      setloading(false);
    });
  };
  const Filter = (event) => {
    const selectedType = event.target.value;
    setType(selectedType);
    setloading(true);

    getAllChallengers(obj, searchParam, 1, selectedType).then((res) => {
      if (res.data) {
        setGetAllChallenge(res.data.data);
        setCurrentPage(res.data.current_page);
        setTotalPage(Math.ceil(res.data.total / res.data.per_page));
      }
      setloading(false);
    });
  };

  const openClaimModal = (challenge_id) => {
    setOpenModal(true);
    getAllChallageGroupList(obj, challenge_id)
      .then((res) => {
        setGetAllList(res.data || []);
      })
      .catch((err) => console.error("Group fetch failed:", err));
  };
  const deleteChallageList = async (id) => {
    const notification = _notificationSystem.current;
    const res = await DeleteChallenge(id, obj);

    if (res.data.message === "Challenge marked as inactive") {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>Challenge List</b> - marked as inactive.
          </div>
        ),
        level: "success",
        position: "bl",
        autoDismiss: 15,
      });

      setloading(true);
      getAllChallengers(obj)
        .then((res) => {
          setGetAllChallenge(res.data.data || []);
          setloading(false);
        })
        .catch((err) => {
          console.error("Error fetching custom utility data:", err);
        });
    } else {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>{res.data.message}</b>
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };

  const handleCLickEdit = (id) => {
    Swal.fire({
      width: "500px",
      title: "<strong><font size='36px'>Are Sure</font></strong>",
      icon: "info",
      html: "<font size='4px'>You want to edit this Challange</font>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
    }).then((result) => {
      if (result.isConfirmed) {
        editChallange(id);
      }
    });
  };
  const addChallenge = () => {
    props.history.push(`/admin/addChallenge`);
  };
  const editChallange = (id) => {
    props.history.push(`/admin/editChallenge/${id}`);
    localStorage.setItem("challengeId", id);
  };
  const handleCLickDelete = (id) => {
    Swal.fire({
      width: "500px",
      title: "<strong><font size='36px'>Are Sure</font></strong>",
      icon: "info",
      html: "<font size='4px'>You want to delete this</font>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteChallageList(id);
      }
    });
  };
  const resetSearch = () => {
    setSearchParam("");
    allChallenge(obj);
    setType("");
  };

  const Groups = <Tooltip id="Groups">Groups</Tooltip>;
  const edit = <Tooltip id="edit">Edit</Tooltip>;
  const Delete = <Tooltip id="Delete">Delete</Tooltip>;
  return (
    <div className="main-content">
      <Grid fluid>
        <NotificationSystem ref={_notificationSystem} />
        <br />
        <Card
          content={
            <>
              <form>
                <div className="table-responsive">
                  <Col>
                    <Card
                      content={
                        <React.Fragment>
                          <Row>
                            <Row
                              className="align-items-center"
                              style={{ marginBottom: "20px" }}
                            >
                              <Col
                                xs={4}
                                sm={4}
                                md={3}
                                lg={3}
                                style={{ display: "flex" }}
                              >
                                <FormControl
                                  style={{ marginTop: "5px" }}
                                  name="search"
                                  placeholder="Search"
                                  type="text"
                                  className="text-input"
                                  value={searchParam}
                                  onChange={(event) => handleSearch(event)}
                                />
                              </Col>
                              <Col
                                xs={4}
                                sm={4}
                                md={3}
                                lg={3}
                                style={{ display: "flex" }}
                              >
                                <select
                                  style={{ marginTop: "5px" }}
                                  onChange={Filter}
                                  name="type"
                                  value={type}
                                  className="form-control"
                                >
                                  <option value="" disabled hidden>
                                    Challenge Type
                                  </option>
                                  <option value="steps">Steps</option>
                                  <option value="calorie">Calorie</option>
                                </select>
                              </Col>
                              &nbsp; &nbsp;
                              <Button
                                style={{ marginTop: "5px" }}
                                onClick={() => resetSearch()}
                              >
                                Reset
                              </Button>
                              <Button
                                style={{ float: "right", marginRight: "10px" }}
                                onClick={() => addChallenge()}
                                className="fl_btn_add_order btn-fill btn btn-default"
                              >
                                Add Challenge <i class="fa fa-plus"></i>
                              </Button>
                            </Row>
                            <Col md={12} style={{ marginTop: "24px" }}>
                              <Table responsive className="desktop-table">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>start date</th>
                                    <th>End date</th>
                                    <th>Package Name</th>
                                    <th>Challage Type</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {loading ? (
                                    <tr>
                                      <td colSpan="10">
                                        <LoadingSpinner />
                                      </td>
                                    </tr>
                                  ) : noRecordFound ||
                                    !getAllChallenge ||
                                    getAllChallenge.length === 0 ? (
                                    <tr>
                                      <td colSpan="10">
                                        <center>No record found</center>
                                      </td>
                                    </tr>
                                  ) : (
                                    getAllChallenge &&
                                    getAllChallenge.map((item) => (
                                      <tr key={item.id}>
                                        <td>{item.name}</td>
                                        <td>{item.start_date}</td>
                                        <td>{item.end_date}</td>
                                        <td>
                                          {(item.catalogue_package_title &&
                                            item.catalogue_package_title
                                              .title) ||
                                            item.catalogue_title ||
                                            null}
                                        </td>
                                        <td>{item.type}</td>
                                        <td>
                                          {item.is_active ? (
                                            <>
                                              <OverlayTrigger
                                                placement="top"
                                                overlay={Delete}
                                              >
                                                <Button
                                                  className="btn-simple btn btn-xs btn-danger"
                                                  simple
                                                  bsStyle="success"
                                                  bsSize="xs"
                                                  style={{ border: "none" }}
                                                  onClick={() =>
                                                    handleCLickDelete(item.id)
                                                  }
                                                >
                                                  <i class="fa fa-times" />
                                                </Button>
                                              </OverlayTrigger>
                                              <OverlayTrigger
                                                placement="top"
                                                overlay={edit}
                                              >
                                                <Button
                                                  simple
                                                  bsStyle="success"
                                                  bsSize="xs"
                                                  style={{ border: "none" }}
                                                  onClick={() =>
                                                    handleCLickEdit(item.id)
                                                  }
                                                >
                                                  <i class="fa fa-edit" />
                                                </Button>
                                              </OverlayTrigger>
                                              <OverlayTrigger
                                                placement="top"
                                                overlay={Groups}
                                              >
                                                <Button
                                                  simple
                                                  bsStyle="success"
                                                  bsSize="xs"
                                                  style={{ border: "none" }}
                                                  onClick={() =>
                                                    openClaimModal(item.id)
                                                  }
                                                >
                                                  <i class="fa fa-group" />
                                                </Button>
                                              </OverlayTrigger>
                                            </>
                                          ) : (
                                            <Button
                                              style={{
                                                background: "red",
                                                padding: "8px 27px",
                                                color: "white",
                                                fontweight: "bold",
                                                borderRadius: "5px",
                                                border: "none",
                                                cursor: "not-allowed",
                                              }}
                                            >
                                              Inactive
                                            </Button>
                                          )}
                                        </td>
                                      </tr>
                                    ))
                                  )}
                                </tbody>
                              </Table>
                            </Col>
                          </Row>
                        </React.Fragment>
                      }
                    />
                    <div style={{ textAlign: "center" }}>
                      <Pagination bsSize="medium">{items}</Pagination>
                    </div>
                  </Col>
                </div>
              </form>
              <Modal
                show={openModal}
                onHide={() => setOpenModal(false)}
                bsSize="large"
              >
                <Modal.Header closeButton>
                  <Modal.Title>Team List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Table>
                    <thead>
                      <tr>
                        <th>Team Name</th>
                        <th>Team code</th>
                        <th>Team Created</th>
                        <th>Team Logo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getAllList.length == 0 ? (
                        <td colspan="10" style={{ textAlign: "center" }}>
                          <h5>No Data Found</h5>{" "}
                        </td>
                      ) : (
                        getAllList.map((u) => (
                          <tr>
                            <td>{u.name}</td>
                            <td>{u.product_code}</td>
                            <td>{u.created_at}</td>
                            <td>
                              {u.profile_url ? (
                                <img
                                  src={u.profile_url}
                                  alt=""
                                  style={{
                                    width: "30px",
                                    objectFit: "cover",
                                    borderRadius: "15px",
                                  }}
                                />
                              ) : (
                                ""
                              )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="btn-fill btn btn-info"
                    variant="secondary"
                    onClick={() => setOpenModal(false)}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </>
          }
        />
      </Grid>
    </div>
  );
};

export default Challengers;
